import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'td-wb-joyride-back-button',
  templateUrl: 'joyride-back-button.component.html',
  styleUrls: ['./joyride-back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JoyrideBackButtonComponent {
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  onClick(): false {
    this.clicked.emit();
    return false;
  }
}
